export default {
  "Adobe Jenson Pro": "adobe-jenson-pro",
  "NyCarlsbergDisplay-Regular": "NyCarlsbergDisplay-Regular",
  "NyCarlsbergDisplay-Bold": "NyCarlsbergDisplay-Bold",
  "NyCarlsbergDisplay-Light": "NyCarlsbergDisplay-Light",
  "System Fonts": "system-ui",
};
